import React from "react";
import { useMediaQuery } from "@mui/material";
import { RadialBarChart, RadialBar, ResponsiveContainer } from "recharts";

const RadialChart = ({ radialData, totalAlerts }) => {
  // breakpoints
  const isSmall = useMediaQuery("(max-width:1600px)");
  const isMediumQuery = useMediaQuery("(max-width:1800px)");
  const isMedium = !isSmall && isMediumQuery;

  // helper function
  const getSize = (small, medium, normal) => {
    if (isSmall) {
      return small;
    } else if (isMedium) {
      return medium;
    } else {
      return normal;
    }
  };

  return (
    <ResponsiveContainer
      width={getSize(160, 180, 230)}
      height={getSize(140, 160, 170)}
      margin={{ top: -95, left: -45 }}
    >
      <RadialBarChart
        cx="50%"
        cy="50%"
        innerRadius={getSize("40%", "45%", "50%")}
        outerRadius={getSize("70%", "75%", "80%")}
        barSize={getSize(8, 9, 10)}
        data={radialData}
        startAngle={90}
        endAngle={-270}
      >
        <RadialBar minAngle={15} background clockWise dataKey="value" />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          className="progress-label"
          style={{ fontSize: getSize("0.8rem", "0.9rem", "1rem") }}
        >
          {totalAlerts}
        </text>
      </RadialBarChart>
    </ResponsiveContainer>
  );
};

export default RadialChart;
